import useSelf from '@opsbase/react-ctrl-self/useSelf';
import useCss from '@opsbase/web-css';
import Horizontal from '@opsbase/web-layout/Horizontal';
import Vertical from '@opsbase/web-layout/Vertical';
import React from 'react';
import AboutSettingsSection from './settingssections/AboutSettingsSection';
import OptionsSettingsSection from './settingssections/OptionsSettingsSection';
import ScoringSettingsSection from './settingssections/ScoringSettingsSection';
import WhereSettingsSection from './settingssections/WhereSettingsSection';
import WhoSettingsSection from './settingssections/WhoSettingsSection';
const makeMyClasses = () => ({
    container1: {
        maxWidth: '45%',
    },
    container2: {
        overflow: 'hidden',
    },
});
export function OpDefinitionEditSettingsTab(props) {
    const { opDefinition, disabled = false, onChange } = props;
    const myCss = useCss(makeMyClasses);
    const self = useSelf();
    const isOpLocked = !(self.isPrimary || self.isSuperUser) && opDefinition.lockEditing;
    const isEditable = !disabled && !isOpLocked;
    const subProps = {
        definition: opDefinition,
        onChange,
        isEditable,
    };
    return (React.createElement(Horizontal, null,
        React.createElement(Vertical, { gutter: true, classes: { root: myCss.container1 } },
            React.createElement(AboutSettingsSection, { ...subProps, isEditable: !disabled, isOpDefLocked: isOpLocked }),
            React.createElement(ScoringSettingsSection, { ...subProps })),
        React.createElement(Vertical, { gutter: true, classes: { root: myCss.container2 } },
            React.createElement(OptionsSettingsSection, { ...subProps }),
            React.createElement(WhereSettingsSection, { ...subProps, isEditable: !disabled, isOpDefLocked: isOpLocked }),
            React.createElement(WhoSettingsSection, { ...subProps }))));
}
export default OpDefinitionEditSettingsTab;
